import { Network } from "@capacitor/network";

// @capacitor/network falls back to navigator.onLine automatically in a plain
// browser (see its own docs), so this is safe to use as-is in the Vite dev
// server too — no separate web-only implementation needed.
export async function isOnline(): Promise<boolean> {
  const status = await Network.getStatus();
  return status.connected;
}

export function onNetworkChange(cb: (online: boolean) => void): () => void {
  const listenerPromise = Network.addListener("networkStatusChange", (status) => {
    cb(status.connected);
  });
  return () => {
    void listenerPromise.then((listener) => listener.remove());
  };
}

// An axios request that never reached the server (offline, DNS failure, a
// captive portal swallowing it) has `.request` set but no `.response`. A 4xx/5xx
// has both. A plain thrown Error (validation, OfflineEditBlockedError, etc.)
// has neither, so this only ever matches genuine network failures.
export function isNetworkError(err: unknown): boolean {
  if (!err || typeof err !== "object") return false;
  const candidate = err as { response?: unknown; request?: unknown };
  return candidate.response === undefined && candidate.request !== undefined;
}
